<template>
    <div :class="{ 'position-relative': !dropup, 'dropup': dropup }">
        <div v-if="boxSelect" class="login-language-select">
            <ul>
                <li
                    v-for="lang in languages"
                    :key="lang.key"
                    :class="{ active: language === lang.key }">
                    <button
                        type="button"
                        class="e3-pointer"
                        @click="selectLanguage(lang.key)">
                        {{ lang.key }}
                    </button>
                </li>
            </ul>
        </div>
        <template v-else>
            <div
                v-click-outside="closeCollapse"
                class="d-flex align-items-center lang-switcher"
                role="button"
                tabindex="0"
                :aria-expanded="showLanguages"
                aria-controls="langCollapse"
                @click="showLanguages = !showLanguages"
                @keydown.enter="showLanguages = !showLanguages"
                @keydown.space.prevent="showLanguages = !showLanguages">
                <span v-if="!landingPage" class="font-weight-bold mr-2 text-uppercase">{{ $t('Choose language') }}: </span>
                <span class="e3-pointer align-items-center d-inline-flex">
                    <span class="selected-lang font-weight-bold mr-auto d-inline-flex align-items-center">
                        <WebIcon class="text-topbar" size="14"/>
                        <span>{{ selectedLangName }}</span>
                    </span>
                    <ChevronDownIcon
                        class="text-primary ml-auto e3-transition"
                        :class="{'e3-rotate-180': showLanguages}"
                        size="22"/>
                </span>
            </div>
            <div id="langCollapse" class="collapse" :class="{'show': showLanguages}">
                <div
                    v-for="lang in unselectedLanguages"
                    :key="lang.key"
                    class="pl-0"
                    @click="setLanguage(lang.key, true)">
                    <span class="e3-user-language e3-pointer">
                        {{ lang.text }}
                    </span>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import WebIcon from '@/common/components/svg-icons/WebIcon.vue';
import ChevronDownIcon from '@/common/components/svg-icons/ChevronDownIcon.vue';

export default {
    props: {
        landingPage: {
            type: Boolean,
            default: false
        },
        boxSelect: {
            type: Boolean,
            default: false
        },
        burger: {
            type: Boolean,
            default: false
        },
        dropup: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showLanguages: false
        };
    },
    computed: {
        ...mapGetters(['languages', 'language', 'mobileMenuVisible']),
        unselectedLanguages() {
            return this.languages.filter(el => el.key !== this.language);
        },
        selectedLangName() {
            const lang = this.languages.find(el => el.key === this.language);
            return lang ? lang.text : '';
        }
    },
    methods: {
        selectLanguage(lang) {
            this.setLanguage(lang);
            this.closeMobile();
        },
        setLanguage(lang, clicked) {
            if (clicked) {
                this.$emit('close');
                this.showLanguages = false;
            }
            this.$store.dispatch('SET_LANGUAGE', lang).catch(() => {
                if (lang !== 'en') {
                    this.setLanguage('en');
                }
            });
        },
        closeMobile() {
            if (this.burger && this.mobileMenuVisible) {
                this.$store.dispatch('CLOSE_MOBILE_MENU');
            }
        },
        closeCollapse() {
            if (this.showLanguages) {
                this.showLanguages = false;
            }
        }
    },
    components: {
        WebIcon,
        ChevronDownIcon
    },
    created() {
        if (!this.landingPage) {
            this.setLanguage(this.$i18n.locale, false);
        }
    }
};
</script>
